

























































































import {
    columnTemplates,
    defaultTableConfig,
    TableConfig,
} from '@/core/components/table';
import { Table } from '@/core/components/table/types';
import {
    ConfigServiceContract,
    CONTRACTS,
    FetchServiceContract,
} from '@/core/contracts';
import { localize } from '@/core/filters';
import { guid } from '@/core/helpers';
import { formatDate } from '@/core/helpers/DateTime';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { User } from '@/dto';
import { DataSource } from '@/types';
import {
    DxColumn,
    DxDataGrid,
    DxEditing,
    DxForm,
    DxPopup,
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import {
    DxAsyncRule,
    DxPatternRule,
    DxValidator,
} from 'devextreme-vue/validator';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxValidator,
        DxAsyncRule,
        DxPatternRule,
    },
})
export default class UsersTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;

    @Inject(CONTRACTS.ConfigService)
    private _configService?: ConfigServiceContract;

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    private formatDate = formatDate;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
            onInitNewRow: e => this.setDefaultData(e.data),
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get passwordOptions() {
        return { mode: 'password' };
    }

    public async nameValidation(params: any) {
        const value = params.value;
        if (!value) {
            return false;
        }
        const url = `/users/${value}/exists`;
        const userExists = await this._fetchService!.get<boolean>(url);
        return !userExists;
    }

    private onEditorPreparing(e: any) {
        if (
            e.dataField === 'name' &&
            e.parentType === 'dataRow' &&
            !e.row.isEditing
        ) {
            e.editorOptions.disabled = true;
        }
    }

    private setDefaultData(user: User) {
        user.isDev = false;
        user.isActive = true;
    }

    private onDoubleClick(e: any) {
        e.component.editRow(e.rowIndex);
    }

    private copyResetLink(key: string) {
        if (this._configService) {
            const identity =
                this._configService.getConfig().Services?.identityURL;

            const link = `${identity}/Account/ResetPassword?key=${key}`;
            navigator.clipboard.writeText(link);

            notify(
                `"${link}" ` + localize('Notify_CopyToClipboard'),
                'success',
                1500
            );
        }
    }

    private async generateResetLink(user: User) {
        if (
            await confirm(
                localize('Users_AddResetLinkConfirmContent'),
                localize('Users_AddResetLinkConfirmTitle')
            )
        ) {
            const data: Partial<User> = { resetKey: guid() };
            const response = await this._fetchService!.put<User>(
                `/users/${user.id}`,
                data
            );
            (this.$refs['data-grid'] as DxDataGrid).instance?.refresh();

            if (response.resetKey) {
                this.copyResetLink(response.resetKey);
            }
        }
    }
}
